import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  Fragment,
} from "react";
import { useHistory, useLocation } from "react-router";
import { useSelector } from "react-redux";
import _, { set } from "lodash";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import ArticleCard from "./components/ArticleCard";
import AddArticleModal from "./components/AddArticleModal";
import EditArticleModal from "./components/EditArticleModal";
import ConfirmationModal from "../../components/ConfirmationModal/index";
import "./index.css";

const Articles = () => {
  const location = useLocation();
  const history = useHistory();
  const [brand_data, setBrandData] = useState({});
  const [brand, setBrand] = useState(null);
  const [role, setRole] = useState(null);
  const [username, setUserName] = useState("");
  const [loading, setLoading] = useState(false);
  const [articles, setArticles] = useState([]);
  const [articleIdToDelete, setArticleIdToDelete] = useState();
  const [filteredArticles, setFilteredArticles] = useState([]);
  const [articleEditing, setArticleEditing] = useState(null);
  const [searchKey, setSearchKey] = useState("");
  const [tab, setTab] = useState("all");
  const deleteArticleBtnRef = useRef();
  const myRole = useSelector((state) => state.myRole);

  useEffect(() => {
    if (!location.state) history.push("/");
    else {
      const { brand, role, username } = location.state;
      setBrand(brand);
      setRole(role);
      setUserName(username);
      setLoading(true);
      Firebase.getBrandDataByID(brand, (brand_data) => {
        if (brand_data) {
          setBrandData(brand_data);
          const { parent } = brand_data;
          Firebase.getArticlesByBrand(brand_data.name, (brand_articles) => {
            Firebase.getArticlesByBrand("Ecosystem", (super_articles) => {
              const articles = [
                ...brand_articles.map((ba) => ({ ...ba, type: "brand" })),
                ...super_articles.map((sa) => ({ ...sa, type: "super" })),
              ];
              const clone_articles = _.cloneDeep(articles);
              if (parent) {
                // I am inside sub brand and wanna get parent articles
                Firebase.getBrandDataByID(parent, (parentBrand_Data) => {
                  const parentBrandName = parentBrand_Data.name;
                  Firebase.getArticlesByBrand(parentBrandName, (res) => {
                    setLoading(false);
                    const parentArticles = res.filter((a) => a.postToSub);
                    setArticles(
                      [...clone_articles, ...parentArticles].sort(
                        (a, b) => b.time - a.time
                      )
                    );
                    setFilteredArticles(
                      [...clone_articles, ...parentArticles].sort(
                        (a, b) => b.time - a.time
                      )
                    );
                  });
                });
              } else {
                // I am inside normal brand and wanna get articles
                setLoading(false);
                if (myRole === "isUmbrella" && brand_data.umbrella) {
                  const articles = clone_articles.filter(
                    (item) => item.postToSub
                  );
                  setArticles(articles.sort((a, b) => b.time - a.time));
                  setFilteredArticles(articles.sort((a, b) => b.time - a.time));
                } else
                  setArticles(clone_articles.sort((a, b) => b.time - a.time));
                setFilteredArticles(
                  clone_articles.sort((a, b) => b.time - a.time)
                );
              }
            });
          });
        }
      });
    }
  }, [location]);

  const handleClickCopyLink = useCallback((id) => {
    document.getElementById("notify").click();
    const link = brand_data.bespokeUrl
      ? `${brand_data.bespokeUrl}/magazine/${id}`
      : `https://ecosystem.club/${brand_data.name}/magazine/${id}`;
    navigator.clipboard.writeText(link);
  });

  const handleRemoveArticle = (id, brandName) => {
    Firebase.removeArticle(id, brandName);
  };

  const renderContent = () => {
    return (
      <div className="articles-content">
        <button
          className="btn-add btn-brand-hex"
          style={{
            backgroundColor: "white",
            color: "black",
            "--hover-text-color": brand_data.white ? "white" : "black",
            "--hover-color": brand_data.hex,
          }}
          data-toggle="modal"
          data-target="#add_article_modal"
        >
          <p
            style={{
              fontSize: "65px",
              lineHeight: "65px",
            }}
          >
            +
          </p>
          <p className="article-item-text">Add a new article</p>
        </button>
        <div className="article-items">
          {filteredArticles.map((article) => (
            <Fragment key={article.id}>
              <ArticleCard
                content={article}
                brandName={brand_data.name}
                id={article.id}
                hex={brand_data.hex}
                white={brand_data.white}
                onEdit={() => handleClickEdit(article)}
                onShare={() => handleClickSharing(article.id)}
                onCopyLink={() => handleClickCopyLink(article.id)}
                removeArticle={() => {
                  setArticleIdToDelete(article.id);
                  deleteArticleBtnRef.current.click();
                }}
              />
            </Fragment>
          ))}
        </div>
      </div>
    );
  };
  const renderArticleHeader = () => {
    return (
      <div className="article-header">
        <div className="search-box">
          <input
            placeholder="Search by name"
            type="text"
            value={searchKey}
            onChange={({ target }) => {
              setSearchKey(target.value);
              if (target.value === "") {
                setFilteredArticles(articles);
              } else {
                const filtered = articles.filter((article) =>
                  article.title
                    .toLowerCase()
                    .includes(target.value.toLowerCase())
                );
                setFilteredArticles(filtered);
              }
            }}
            name="search"
            autoComplete="off"
            aria-autocomplete="none"
          />
          <button onClick={onSearch}>
            <i className="fa fa-search" />
          </button>
        </div>
        <button
          className="btn btn-white"
          style={{
            backgroundColor: tab === "all" ? brand_data.hex : "white",
            color:
              tab === "all" ? (brand_data.white ? "white" : "black") : "black",
          }}
          onClick={onAllArticles}
        >
          All articles
        </button>
        <button
          className="btn btn-white"
          style={{
            backgroundColor: tab === "prospects" ? brand_data.hex : "white",
            color:
              tab === "prospects"
                ? brand_data.white
                  ? "white"
                  : "black"
                : "black",
          }}
          onClick={onProspectsArticles}
        >
          Articles for prospects
        </button>
        <button
          className="btn btn-white"
          style={{
            backgroundColor: tab === "members" ? brand_data.hex : "white",
            color:
              tab === "members"
                ? brand_data.white
                  ? "white"
                  : "black"
                : "black",
          }}
          onClick={onMembersArticles}
        >
          Articles for members
        </button>
      </div>
    );
  };
  const onSearch = () => {};
  const onAllArticles = () => {
    setTab("all");
    setSearchKey("");
    setFilteredArticles(articles);
  };
  const onProspectsArticles = () => {
    setTab("prospects");
    setSearchKey("");
    setFilteredArticles(
      articles.filter(
        (a) => a.toReferrals === undefined || a.toReferrals === true
      )
    );
  };
  const onMembersArticles = () => {
    setTab("members");
    setSearchKey("");
    setFilteredArticles(
      articles.filter((a) => a.toMembers === undefined || a.toMembers === true)
    );
  };
  const handleClickEdit = (article) => {
    setArticleEditing(article);
  };
  const handleClickSharing = (articleId) => {
    document.getElementById("notify").click();
    let brandname = brand_data.name.replace(/\s/g, "");
    let value =
      "https://ecosystem.club/" + brandname + "?articleId=" + articleId;
    navigator.clipboard.writeText(value);
  };
  const handleClickAdd = (article) => {
    article.username = username;
    article.uid = localStorage.getItem("uid");
    article.from_admin = true;
    article.time = new Date().getTime();
    if (myRole === "isUmbrella" && brand_data.umbrella) {
      article.postToSub = true;
    }
    Firebase.addArticle(article, brand_data.name);
  };
  const handleClickUpdate = (article) => {
    article.time = new Date().getTime();
    Firebase.updateArticle(brand_data.name, article.id, article);
  };
  return (
    <div id="page-container" className="articles-container">
      <Header
        username={username}
        role={role}
        logo={brand_data.logo}
        brand={brand}
        brandName={brand_data.name}
        is_property_brand={brand_data.is_property_brand}
      />
      <main id="main-container">
        {loading && (
          <div className="loading">
            <i className="fa fa-4x fa-sync fa-spin text-muted" />
          </div>
        )}
        {!loading && renderArticleHeader()}
        {!loading && renderContent()}
        <AddArticleModal onAdd={handleClickAdd} brand={brand_data} />
        <EditArticleModal
          initial={articleEditing}
          onUpdate={handleClickUpdate}
          brand={brand_data}
          deleteArticleBtnRef={deleteArticleBtnRef}
          setArticleIdToDelete={setArticleIdToDelete}
        />
        <ConfirmationModal
          id="delete_article"
          title="Are you sure you want to delete this article?"
          onClick={() =>
            handleRemoveArticle(articleIdToDelete, brand_data.name)
          }
          hex={brand_data.hex}
          white={brand_data.white}
        />
        <button
          style={{ display: "none" }}
          ref={deleteArticleBtnRef}
          data-toggle="modal"
          data-target="#delete_article"
        />
      </main>
    </div>
  );
};

export default Articles;



// WEBPACK FOOTER //
// ./src/screens/Articles/index.js